import * as THREE from "three";
// import { useControls } from "leva";
import { Suspense, useEffect, useRef, useMemo, forwardRef, useState } from "react";
// import { Points } from 'three'
import { extend, useFrame, createPortal, useThree, Canvas } from "@react-three/fiber";
import { PerspectiveCamera, Center, OrthographicCamera, OrbitControls, shaderMaterial, useFBO, Float, Text3D, ScrollControls, Scroll, useScroll } from "@react-three/drei";
// import AnimText from "./AnimText.tsx";
import glsl from "babel-plugin-glsl/macro";
import { v4 as uuidv4 } from "uuid";
import Experience from './Experience.tsx'

// import PageThree from "./PageThree";
// import { Perf } from "r3f-perf";


// NEED TO FIND SOLUTION FOR RESPONSIVE TEXT. 
// WIDTH AND HEIGHT NEED A FUNCTION 
//https://www.youtube.com/watch?v=tyNt9Qse1mg
//{WINDOW.innerwidth x WINDOW.innerheight}


extend({
  Points: {
    scroll(delta) {
      this.position.z += delta
    },
  },
})


function TextureScene() {
  
  // const scroll = useScroll()
  // const mesh = useRef()
  // const mbp16 = useRef()
  const planer = useRef()
  // const data = useScroll()
  // const planer = useRef()
  useFrame(() => {
    // mesh.current.rotation.x = mesh.current.rotation.y = mesh.current.rotation.z += 0.01
  })

  // const [dimensions, setDimensions] = useState({
  //   height: window.innerHeight,
  //   width: window.innerWidth,
  // });


  // useEffect(() => {
  //   const debouncedHandleResize = debounce(function handleResize() {
  //     setDimensions({
  //       height: window.innerHeight,
  //       width: window.innerWidth,
  //     });
  //   }, 3);

  //   window.addEventListener("resize", debouncedHandleResize);

  //   return (_) => {
  //     window.removeEventListener("resize", debouncedHandleResize);
  //   };
  // }, []);




  useFrame(() => {
    // const r1 = scroll.range(0 / 4, 1 / 4)
    // const r2 = scroll.range(1 / 4, 1 / 4)
    // const r3 = scroll.visible(4 / 5, 1 / 5)
    // mbp16.current.rotation.y = THREE.MathUtils.damp(group.current.rotation.y, (-Math.PI / 1.45) * r2, 4, delta)
    // planer.current.rotation.x = 0
    // planer.current.position.y = 0
    // planer.current.position.z = -.6
    // planer.current.scale.x = 16.6
    // planer.current.scale.y = 10
    // planer.current.rotation.z = 0
  })

  return (<>
{/* <ScrollControls  pages={5}>
  <Scroll > */}
  {console.log("Scroll component rendered")}  
  {/* <Center position={[0, 0, -3]}> */}
    {/* <Float  
    // rotation={[Math.PI / 0.5, 0, 0]}
    //  rotationIntensity={1} 
    //  floatIntensity={1.1} 
    //  speed={5.5}
     > */}
    {/* <mesh  ref={mbp16} position={[0, 0, 0]} > */}

    <mesh>
    <Experience/>
    </mesh>

    {/* ref={planer} position={[0, 0, 0]} */}
    {/* </mesh>  */}
    {/* </Scroll> */}


    {/* </Float> */}
    {/* </Center> */}
    {/* <Scroll > */}
    <mesh ref={planer} position={[0, 0, -10]}  >
      
    <planeGeometry args={[120, 15, 1, 1]}   />
    <meshPhongMaterial emissive='white' opacity="0.5"/>
    </mesh>
    {/* </Scroll> */}
    {/* </ScrollControls> */}
    </>
  )
}


const WaveShaderMaterial2 = shaderMaterial(
{   uHover: new THREE.Vector3(0, 0, 0),
    uRadius: 0.015,
    uZoom: 1,
    uDir: 1,
    uNormalize: false,
    uTime: 0,
    psize: 7.0,
    uAspect: 0,

    // size: { viewport.width / 1600},
    // pSize : {[viewport.width, viewport.height, 1]},
    uMouse: new THREE.Vector2(-0.5,0.5),
    uHover: new THREE.Vector3(0, 0, 0),
    uTexture: new THREE.Texture(),
    uElevation: 0.02,
    uFrequency: new THREE.Vector2(0.,0.),
    uColorStart: new THREE.Color('#ffffff'),
    uColorEnd: new THREE.Color('#000000') },
  glsl`
  uniform vec2 uMouse;
  uniform vec3 uHover;
  uniform float uRadius;
  uniform float uDir;
  uniform bool uNormalize;
  uniform float psize;
  uniform float uElevation;
  uniform vec2 uFrequency;
  uniform float uAspect;

  // uniform float pointSize;

  varying vec2 vUv;
  varying vec3 vPosition;

  void main() {

  vUv = uv;
  vec3 pos = position;
  float mouseRadius = 0.75;
  float dist = distance(pos.xy, uMouse);
  float strength = dist/mouseRadius;
  strength = smoothstep(0.5,0.05, strength);


  float dx = cos(uMouse.x);
  float dy = uMouse.y;
  float angleangle = atan(dx, dy);

  pos.x += sin(angleangle)*strength*0.1;
  pos.y += cos(angleangle)*strength*0.1;
  pos.z = angleangle*strength*0.1;

  // gl_PointSize = 10.0;

  // gl_PointSize = pSize;

  vec4 modelPosition = modelMatrix * vec4(pos, 1.0);
  vec4 viewPosition = viewMatrix * modelPosition;
  vec4 projectionPosition = projectionMatrix * viewPosition;



  gl_PointSize = uAspect * 7.14;
  // Size attenuation;
  // gl_PointSize *= (1.0 / - viewPosition.z);
  // gl_PointSize =  14. *( 1. / - viewPosition.y);


  gl_Position = projectionPosition;}
  `,
  glsl`
    precision mediump float;
    uniform float uTime;
    uniform sampler2D uTexture;
    uniform vec3 uColor;

    varying vec2 vUv;

    float PI = 3.14;

float map(float value, float min1, float max1, float min2, float max2) {
    return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
}

void main() {

       {}
    float r = 0.0, delta = 0.0, alpha = 1.0;
    vec2 cxy = 2.0 * gl_PointCoord - 1.0;
    r = dot(cxy, cxy);
    if (r > 1.0) {
        discard;
    }
    
    vec4 tt = texture2D(uTexture, vUv);
    gl_FragColor = vec4(vUv,0,1.);
    gl_FragColor = tt;
    gl_FragColor = vec4(vUv,1.0,0.5 - tt.r);
    if(tt.r>0.1 && tt.b>0.1 && tt.g>0.1) discard;

    // vec3 col = mix(vUv, vDisplace);
    // gl_FragColor.rgba = vec4(col, 0.008);

    }
  `
)

extend({ WaveShaderMaterial2 })



            const FBOScene = ({ props }) => {

              // const plane = useRef()
              // useFrame(() => (plane.current.position.y = plane.current.rotation.y += 0.01))
            
              const target = useFBO(props)
              // const [pointSize, setPointSize] = useState(16.0);

              const cam = useRef()
              const scene = useMemo(() => {
                const scene = new THREE.Scene()
                return scene
              }, [])

              const mouseTarget = useRef({ x: 0, y: 0 });

              const r = useRef(0);
              const handlePointerMove = (e) => {
                hoverTarget.current.x = e.point.x;
                hoverTarget.current.y = e.point.y;
                hoverTarget.current.z = e.point.z;
              };
              const handlePointerEnter = () => (r.current = radius);
              const handlePointerLeave = () => (r.current = 0);


                 useEffect(() => {
                const onMouseMove = (e) => {
                  mouseTarget.current.x = e.clientX / window.innerWidth - 0.5;
                  mouseTarget.current.y = e.clientY / window.innerHeight - 0.5;
                };
                window.addEventListener("mousemove", onMouseMove);
                return () => window.removeEventListener("mousemove", onMouseMove);
              }, []);

              // onWindowResize = () => {
              //   camera.aspect = window.innerWidth / window.innerHeight;
              //   camera.updateProjectionMatrix();
              //   renderer.setSize(window.innerWidth, window.innerHeight);
              //   };

              // useEffect(() => {
              //   function handleResize() {
              //     setPointSize(window.innerWidth / window.innerHeight);
              //   }
              //   window.addEventListener('resize', handleResize);
              //   handleResize();
              //   return () => window.removeEventListener('resize', handleResize);
              // }, []);

              // useEffect(() => {
              //   const handleResize = () => {
              //     const aspect = window.innerWidth / window.innerHeight;
              //     pointSize.current = map(0, 2, 0.1, 2); 
              //   };
              //   window.addEventListener('resize', handleResize);
              //   handleResize();
              //   return () => window.removeEventListener('resize', handleResize);
              // }, []);
              


              useFrame((state) => {
                // cam.current.position.z = 5 + Math.sin(state.clock.getElapsedTime() * 1.5) * 2
                
                state.gl.setRenderTarget(target)
                state.gl.render(scene, cam.current)
                state.gl.setRenderTarget(null)

                shader.current.uMouse = [

                // ]
                  mouseTarget.current.x,
                  -mouseTarget.current.y ]
                  
              })
              const plane = useRef()
              const handleScroll = event => {
                plane.current.scroll(event.deltaY)
              }

              // const viewport = useThree(state => state.viewport)

              const shader = useRef()
              useFrame(({ clock }) => (shader.current.uTime = clock.getElapsedTime()))

              const { getCurrentViewport } = useThree(state => state.viewport)
              const viewport = getCurrentViewport()

              const aspect = viewport.width / viewport.height

              useFrame((state) => { 
                shader.current.uAspect = aspect
                console.log(aspect)

              })


              return (
                <>
                  <PerspectiveCamera ref={cam} position={[0, 0, 2]} />
      
                  {/* <OrthographicCamera ref={cam} position={[0, 0, 1]} /> */}
                  {createPortal(<TextureScene />, scene)}

                  {/* <mesh scale={[viewport.width, viewport.height, 1]}> */}
                    {/* <planeGeometry />
                  </mesh> */}


                  <points
                    {...props}
                    ref={plane}
                    onWheel={handleScroll}
                    scale={[viewport.width, viewport.height, 1]}
                    position={[0, 0, 0]}
                    // size={15}
                    >

                    {/* May need to make this Plane responsive.  */}
                    
                    <planeGeometry 
                    args={[viewport.width / 5, viewport.height / 4,  aspect * 200, aspect *  100]}
                    />
                    {/* <shaderMaterial /> */}

                    {/* <PointMaterial transparent vertexColors size={15} sizeAttenuation={false} depthWrite={false} /> */}

                    <waveShaderMaterial2 ref={shader} uTexture={target.texture}   />
                  </points>
         
                </>
              )}

              const ForwardedFBOScene = forwardRef(FBOScene)


              export default function Stamp2() {
                return (
                  // <Canvas>
                  //   {/* <OrbitControls /> */}
                  //       <OrbitControls enabled={false}
                  //         minAzimuthAngle={-Math.PI / 4}
                  //         maxAzimuthAngle={Math.PI / 4}
                  //         minPolarAngle={Math.PI / 6}
                  //         maxPolarAngle={Math.PI - Math.PI / 6}
                  //          />
                    <>
                    <Suspense fallback={null}>
                      <ForwardedFBOScene multisample samples={8} stencilBuffer={false} format={THREE.RGBFormat} />
                    </Suspense>
                    {/* <Loader /> */}
                    </>

                  // </Canvas>
                )
              }
              